import {
  SET_ROLES,
  SET_ROLES_OPTIONS,
  GET_ROLES,
  REFRESH_ROLES,
} from "./types";
const initialState = {
  initialize: true,
  refresh: false,
  isRequesting: false,
  loadMore: true,
  roles: [],
  limit: 10,
  page: 1,
  lastPage: 0,
  from: 0,
  to: 0,
  total: 0,
  pages: [],

  //option
  initializeOption: true,
  options: [],
};

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case REFRESH_ROLES:
      return {
        ...state,
        limit: 10,
        page: 1,
        initialize: true,
        refresh: true,
        isRequesting: false,
        loadMore: true,
        roles: [],

        //option
        initializeOption: true,
        options: [],
      };

    case GET_ROLES:
      return {
        ...state,
        refresh: false,
        isRequesting: true,
      };

    case SET_ROLES:
      // let newRoles = state.roles;
      // payload.data.forEach((r) => {
      //   const role = state.roles.filter((sr) => sr.id === r.id);
      //   if (!role.length) {
      //     newRoles.push(r);
      //   }
      // });

      const tempPages = [];

      if(payload.lastPage > 0 && state.lastPage != payload.lastPage) {
        for(let i = 1; i <= payload.lastPage; i++) {
          tempPages.push(i);
        }
      }

      return {
        ...state,
        isRequesting: false,
        initialize: false,
        page: payload.page,
        loadMore: payload.loadMore,
        // roles: newRoles,  // Use this to add more items on the current list when using a load more button or an intersection to load more items.
        roles: payload.data,
        pages: tempPages.length > 0 ? tempPages : state.pages
      };

    case SET_ROLES_OPTIONS:
      return {
        ...state,
        isRequesting: false,
        initializeOption: false,
        options: payload,
      };

    default:
      return state;
  }
};

export default reducer;
